// extracted by mini-css-extract-plugin
export var copyableField = "_pf-4";
export var customerBadge = "_pf-0";
export var customerInfoTitle = "_pf-2";
export var details = "_pf-1";
export var dropdownContainer = "_pf-5";
export var dropdownImage = "_pf-6";
export var editAssigneeForm = "_pf-a";
export var editButton = "_pf-3";
export var email = "_pf-7";
export var hidden = "_pf-d";
export var input = "_pf-8";
export var saveButton = "_pf-b";
export var shopifyIcon = "_pf-c";
export var suggestionBadge = "_pf-e";
export var suggestionText = "_pf-f";
export var username = "_pf-9";